/**
 * storage/rows.js — lectura defensiva del shape de query (deuda de tuning 2026-06: antes duplicado
 * con nombre en outbox.js y dead-letter.js).
 *
 * el backend SQLite nativo (@capacitor-community/sqlite) y los backends web (opfs-sahpool/wa-sqlite/sql.js detras del StorageAdapter)
 * devuelven `{ values: [objetos] }`; estos helpers toleran resultados null/undefined sin lanzar.
 * Modulo PURO (cero imports): importable desde cualquier capa sin arrastrar el plugin.
 */

/** Filas de un resultado de query, o [] si no hay. */
export function rowsOf (result) {
  return (result && result.values) || []
}

/** Primera fila de un resultado de query, o null si no hay. */
export function firstRow (result) {
  const rows = rowsOf(result)
  return rows.length ? rows[0] : null
}
